var items = {
  "block.minecraft.air": "hawo",
  "block.minecraft.stone": "dhagax",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granite polished",
  "block.minecraft.diorite": "diorite",
  "block.minecraft.polished_diorite": "granite polished",
  "block.minecraft.andesite": "andesite",
  "block.minecraft.polished_andesite": "smooth andesite",
  "block.minecraft.grass_block": "block grass",
  "block.minecraft.dirt": "wasakh",
  "block.minecraft.coarse_dirt": "stony ground",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "crimson nylium",
  "block.minecraft.warped_nylium": "dagaalkii nylium",
  "block.minecraft.cobblestone": "cobblestone",
  "block.minecraft.oak_planks": "qorshooyin mugdi",
  "block.minecraft.spruce_planks": "qorshaha deedka",
  "block.minecraft.birch_planks": "qorshaha birch",
  "block.minecraft.jungle_planks": "qorshaha jungle",
  "block.minecraft.acacia_planks": "qorshaha acacia",
  "block.minecraft.dark_oak_planks": "qorshooyin mugdi ah miro",
  "block.minecraft.crimson_planks": "planson planson",
  "block.minecraft.warped_planks": "diyaaradaha dagaalka",
  "block.minecraft.oak_sapling": "oak sapling",
  "block.minecraft.spruce_sapling": "daadi sapling",
  "block.minecraft.birch_sapling": "birch sapling",
  "block.minecraft.jungle_sapling": "jungle sapling",
  "block.minecraft.acacia_sapling": "acacia sapling",
  "block.minecraft.dark_oak_sapling": "madow oak sapling",
  "block.minecraft.bedrock": "bedrock",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "red sand",
  "block.minecraft.gravel": "isbahaysiga",
  "block.minecraft.gold_ore": "hadal dahab ah",
  "block.minecraft.iron_ore": "iron mare",
  "block.minecraft.coal_ore": "dhuxul ore",
  "block.minecraft.nether_gold_ore": "nether gold ore",
  "block.minecraft.oak_log": "qoraallo kulul",
  "block.minecraft.spruce_log": "daadi taariikhda",
  "block.minecraft.birch_log": "diiwaangelinta birch",
  "block.minecraft.jungle_log": "diiwaangelinta jungle",
  "block.minecraft.acacia_log": "diiwaanka acacia",
  "block.minecraft.dark_oak_log": "mishiinka madow",
  "block.minecraft.crimson_stem": "dembiilaha dambiilaha",
  "block.minecraft.warped_stem": "stem steped",
  "block.minecraft.stripped_oak_log": "xirmay oak log",
  "block.minecraft.stripped_spruce_log": "lasoco xariga loo yaqaan 'spruce log'",
  "block.minecraft.stripped_birch_log": "xarig bir ah",
  "block.minecraft.stripped_jungle_log": "diiwaanka jungle",
  "block.minecraft.stripped_acacia_log": "diiwaan gelinta acacia",
  "block.minecraft.stripped_dark_oak_log": "qufulkii loo yaqaan",
  "block.minecraft.stripped_crimson_stem": "dambiistaha loo yaqaan 'crimson stem'",
  "block.minecraft.stripped_warped_stem": "stem stpedpped war stem",
  "block.minecraft.stripped_oak_wood": "dhuftay oak",
  "block.minecraft.stripped_spruce_wood": "alwaax la gooyay",
  "block.minecraft.stripped_birch_wood": "alwaax gubatay",
  "block.minecraft.stripped_jungle_wood": "dhuftay jungle",
  "block.minecraft.stripped_acacia_wood": "stacpped acacia wood",
  "block.minecraft.stripped_dark_oak_wood": "dhuftay madow oak wood",
  "block.minecraft.stripped_crimson_hyphae": "dambiistaha loo yaqaan 'crimson hyphae'",
  "block.minecraft.stripped_warped_hyphae": "hyphae dagaal difaacay",
  "block.minecraft.oak_wood": "oak",
  "block.minecraft.spruce_wood": "gran wood",
  "block.minecraft.birch_wood": "geedka birch",
  "block.minecraft.jungle_wood": "hawdka alwaax",
  "block.minecraft.acacia_wood": "acacia alwaax",
  "block.minecraft.dark_oak_wood": "dhirta madow geedka",
  "block.minecraft.crimson_hyphae": "dambiilaha caanka ah",
  "block.minecraft.warped_hyphae": "hyphae dagaal",
  "block.minecraft.oak_leaves": "caleemaha oak",
  "block.minecraft.spruce_leaves": "gran leaves",
  "block.minecraft.birch_leaves": "caleemaha birch",
  "block.minecraft.jungle_leaves": "hawdka caleen",
  "block.minecraft.acacia_leaves": "caleenta acacia",
  "block.minecraft.dark_oak_leaves": "caleemaha geedkii mugdiga",
  "block.minecraft.sponge": "isbonji",
  "block.minecraft.wet_sponge": "isbonji qoyan",
  "block.minecraft.glass": "galaas",
  "block.minecraft.lapis_ore": "lapis lazuli ore",
  "block.minecraft.lapis_block": "lapis lazuli block",
  "block.minecraft.dispenser": "fasax",
  "block.minecraft.sandstone": "sandstone",
  "block.minecraft.chiseled_sandstone": "qoray sandstone",
  "block.minecraft.cut_sandstone": "iska yaree sanduuqa",
  "block.minecraft.note_block": "xusuus qor",
  "block.minecraft.powered_rail": "korantada biraha",
  "block.minecraft.detector_rail": "dareemayaal biraha",
  "block.minecraft.sticky_piston": "dhegdheg qalab",
  "block.minecraft.cobweb": "webka",
  "block.minecraft.grass": "cows",
  "block.minecraft.fern": "fern",
  "block.minecraft.dead_bush": "baadiyaha dhintay",
  "block.minecraft.seagrass": "cawska badda",
  "block.minecraft.sea_pickle": "qajaar badda",
  "block.minecraft.piston": "qalab",
  "block.minecraft.white_wool": "dhogor cad",
  "block.minecraft.orange_wool": "dhogorta oranji",
  "block.minecraft.magenta_wool": "dhogorta magneta",
  "block.minecraft.light_blue_wool": "dhogorta dhalaalaya buluug",
  "block.minecraft.yellow_wool": "dhogor huruud ah",
  "block.minecraft.lime_wool": "dhogor lime",
  "block.minecraft.pink_wool": "dhogor casaan",
  "block.minecraft.gray_wool": "wool cirro",
  "block.minecraft.light_gray_wool": "wool light grey light",
  "block.minecraft.cyan_wool": "cyan wool",
  "block.minecraft.purple_wool": "wple wool",
  "block.minecraft.blue_wool": "wool buluug ah",
  "block.minecraft.brown_wool": "wool brown",
  "block.minecraft.green_wool": "wool cagaaran",
  "block.minecraft.red_wool": "wool cas",
  "block.minecraft.black_wool": "wool madow",
  "block.minecraft.dandelion": "løvetann",
  "block.minecraft.poppy": "casaan ubax",
  "block.minecraft.blue_orchid": "buluug ubax",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "haustonia cawlan",
  "block.minecraft.red_tulip": "ubax guduudan",
  "block.minecraft.orange_tulip": "tulip oranji",
  "block.minecraft.white_tulip": "ubax cad",
  "block.minecraft.pink_tulip": "ubax guduudan khafiif",
  "block.minecraft.oxeye_daisy": "chamomile",
  "block.minecraft.cornflower": "miisaanka qulqulka",
  "block.minecraft.lily_of_the_valley": "tufaaxa dooxada",
  "block.minecraft.wither_rose": "waaba kor u kacay",
  "block.minecraft.brown_mushroom": "likaha bunn",
  "block.minecraft.red_mushroom": "likaha guduudan",
  "block.minecraft.crimson_fungus": "crimson fungus",
  "block.minecraft.warped_fungus": "fangaska fangas",
  "block.minecraft.crimson_roots": "xididdada gaduudka",
  "block.minecraft.warped_roots": "xididdada dagaallada",
  "block.minecraft.nether_sprouts": "noocyada ee loo yaqaan 'nether sprouts'",
  "block.minecraft.weeping_vines": "uruurinta geedaha",
  "block.minecraft.twisting_vines": "wareejinta vine",
  "block.minecraft.sugar_cane": "sonkorta cawsduur",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "dhir dheer",
  "block.minecraft.gold_block": "block oo dahab",
  "block.minecraft.iron_block": "block ee iron",
  "block.minecraft.oak_slab": "dhuxusha xargaha",
  "block.minecraft.spruce_slab": "dhir xargaha",
  "block.minecraft.birch_slab": "bjørk xargaha",
  "block.minecraft.jungle_slab": "duurjoogta xargaha",
  "block.minecraft.acacia_slab": "qudhac ah xargaha",
  "block.minecraft.dark_oak_slab": "madow dhuxusha xargaha",
  "block.minecraft.crimson_slab": "crimson slab",
  "block.minecraft.warped_slab": "dagaalkii slab",
  "block.minecraft.stone_slab": "stone bulukeeti",
  "block.minecraft.smooth_stone_slab": "santuuq dhagax siman",
  "block.minecraft.sandstone_slab": "sandstone bulukeeti",
  "block.minecraft.cut_sandstone_slab": "iska yaree sandstone slab",
  "block.minecraft.petrified_oak_slab": "petvidence oak slab",
  "block.minecraft.cobblestone_slab": "samysan bulukeeti",
  "block.minecraft.brick_slab": "lebbiska xargaha",
  "block.minecraft.stone_brick_slab": "dhagax dhagax",
  "block.minecraft.nether_brick_slab": "nether brick slab",
  "block.minecraft.quartz_slab": "quartz slab",
  "block.minecraft.red_sandstone_slab": "red sandstone slab",
  "block.minecraft.cut_red_sandstone_slab": "cut red sandstone slab",
  "block.minecraft.purpur_slab": "ujeeddooyin slab",
  "block.minecraft.prismarine_slab": "prismarine xargaha",
  "block.minecraft.prismarine_brick_slab": "prismarine lebbiska xargaha",
  "block.minecraft.dark_prismarine_slab": "madow prismarine xargaha",
  "block.minecraft.smooth_quartz": "xannibaadda quartz",
  "block.minecraft.smooth_red_sandstone": "siman red sandstone",
  "block.minecraft.smooth_sandstone": "sandstone siman",
  "block.minecraft.smooth_stone": "dhagax jilicsan",
  "block.minecraft.bricks": "lebenkii",
  "block.minecraft.tnt": "dynamite",
  "block.minecraft.bookshelf": "shelf buugga",
  "block.minecraft.mossy_cobblestone": "ajaa cawska",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "toosh",
  "block.minecraft.end_rod": "dhamaadka usha",
  "block.minecraft.chorus_plant": "warshad chorus",
  "block.minecraft.chorus_flower": "ubax chorus",
  "block.minecraft.purpur_block": "ujeeddada foosha",
  "block.minecraft.purpur_pillar": "tiirarka ujacaa",
  "block.minecraft.purpur_stairs": "jaranjarooyinka ujeeddada",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "talaabooyinka oak",
  "block.minecraft.chest": "sanduuq",
  "block.minecraft.diamond_ore": "dheeman dheeman",
  "block.minecraft.diamond_block": "joojinta ee dheeman",
  "block.minecraft.crafting_table": "workbench",
  "block.minecraft.farmland": "beeraley",
  "block.minecraft.furnace": "foornada",
  "block.minecraft.ladder": "jaranjarada",
  "block.minecraft.rail": "biraha",
  "block.minecraft.cobblestone_stairs": "jaranjarooyinka cobblestone",
  "block.minecraft.lever": "kabaal",
  "block.minecraft.stone_pressure_plate": "cadaadiska cadaadiska dhagaxa",
  "block.minecraft.oak_pressure_plate": "mashiinka cadaadiska",
  "block.minecraft.spruce_pressure_plate": "daadi saxanka cadaadiska",
  "block.minecraft.birch_pressure_plate": "cadaadiska birch cadaadiska",
  "block.minecraft.jungle_pressure_plate": "cadaadiska cadaadiska jungle",
  "block.minecraft.acacia_pressure_plate": "cadaadiska cadaadiska acacia",
  "block.minecraft.dark_oak_pressure_plate": "cadaadiska cadaadiska acacia",
  "block.minecraft.crimson_pressure_plate": "cadaadiska cadaadiska",
  "block.minecraft.warped_pressure_plate": "cadaadiska cadaadiska dagaal",
  "block.minecraft.polished_blackstone_pressure_plate": "cadaadiska cadaanka madoow ee cadaanka ah",
  "block.minecraft.redstone_ore": "redstone macdanta",
  "block.minecraft.redstone_torch": "redstone shuclada",
  "block.minecraft.snow": "baraf",
  "block.minecraft.ice": "baraf",
  "block.minecraft.snow_block": "barafka barafka",
  "block.minecraft.cactus": "tiin",
  "block.minecraft.clay": "clay",
  "block.minecraft.jukebox": "jukebox",
  "block.minecraft.oak_fence": "bowd oak",
  "block.minecraft.spruce_fence": "bowd gran",
  "block.minecraft.birch_fence": "deedka birch",
  "block.minecraft.jungle_fence": "xayndaabka geedka tropical",
  "block.minecraft.acacia_fence": "xayndaabka acacia",
  "block.minecraft.dark_oak_fence": "xayndaabka oak madoow",
  "block.minecraft.crimson_fence": "garyaqaan fardowso",
  "block.minecraft.warped_fence": "dayrka dagaalka",
  "block.minecraft.pumpkin": "bocor",
  "block.minecraft.carved_pumpkin": "xaraash",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "soul ciid",
  "block.minecraft.soul_soil": "nafta",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "basalt polured",
  "block.minecraft.soul_torch": "soul torch",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "jack olantern",
  "block.minecraft.oak_trapdoor": "oak hatch",
  "block.minecraft.spruce_trapdoor": "koofiyadaha loo yaqaan 'spruce hatch'",
  "block.minecraft.birch_trapdoor": "birch hatch",
  "block.minecraft.jungle_trapdoor": "hatch geedka tropical",
  "block.minecraft.acacia_trapdoor": "acacia hatch",
  "block.minecraft.dark_oak_trapdoor": "madow oak albaabka",
  "block.minecraft.crimson_trapdoor": "crimson trapdoor",
  "block.minecraft.warped_trapdoor": "trapdoor dagaal",
  "block.minecraft.infested_stone": "dhagax la jeexay",
  "block.minecraft.infested_cobblestone": "cudurka loo yaqaan",
  "block.minecraft.infested_stone_bricks": "lebenkii qoray stone",
  "block.minecraft.infested_mossy_stone_bricks": "lebenkii qoray stone",
  "block.minecraft.infested_cracked_stone_bricks": "lebenkii qoray stone",
  "block.minecraft.infested_chiseled_stone_bricks": "bulukeeti xardho",
  "block.minecraft.stone_bricks": "lebenkii dhagaxyada",
  "block.minecraft.mossy_stone_bricks": "jaranjarooyinka lebiska dhagaxa ah",
  "block.minecraft.cracked_stone_bricks": "lebenkii qoray stone",
  "block.minecraft.chiseled_stone_bricks": "lebenkii qoray stone",
  "block.minecraft.brown_mushroom_block": "cube likaha kafee",
  "block.minecraft.red_mushroom_block": "cube likaha casaan",
  "block.minecraft.mushroom_stem": "lugta likaha",
  "block.minecraft.iron_bars": "baararka iron",
  "block.minecraft.chain": "silsilad",
  "block.minecraft.glass_pane": "murayaad",
  "block.minecraft.melon": "qaraha",
  "block.minecraft.vine": "liana",
  "block.minecraft.oak_fence_gate": "albaabka oak fence",
  "block.minecraft.spruce_fence_gate": "albaabada spruce fence",
  "block.minecraft.birch_fence_gate": "albaabka birch fence",
  "block.minecraft.jungle_fence_gate": "albaabka kaymaha jungle",
  "block.minecraft.acacia_fence_gate": "albaabka acacia fence",
  "block.minecraft.dark_oak_fence_gate": "albaabka madow ee oak fence",
  "block.minecraft.crimson_fence_gate": "albaabada fudud",
  "block.minecraft.warped_fence_gate": "albaabka fure albaabka",
  "block.minecraft.brick_stairs": "tallaabooyinka lebenka",
  "block.minecraft.stone_brick_stairs": "jaranjarada dhagaxa dhagaxa",
  "block.minecraft.mycelium": "mycelium",
  "block.minecraft.lily_pad": "lily pad",
  "block.minecraft.nether_bricks": "lebenkii jahannamada",
  "block.minecraft.cracked_nether_bricks": "burburkii nether brick",
  "block.minecraft.chiseled_nether_bricks": "jidadka loo yaqaan 'chiseled nether brick'",
  "block.minecraft.nether_brick_fence": "xayndaabka nezer",
  "block.minecraft.nether_brick_stairs": "jaranjarada nether brick",
  "block.minecraft.enchanting_table": "miiska sixirka",
  "block.minecraft.end_portal_frame": "qaabka end portal",
  "block.minecraft.end_stone": "dhagax dhamaadka",
  "block.minecraft.end_stone_bricks": "dhamaadka dhagaxa dhagaxa",
  "block.minecraft.dragon_egg": "ukunta masduulaagii",
  "block.minecraft.redstone_lamp": "laydhka redstone",
  "block.minecraft.sandstone_stairs": "jaranjarooyinka sandstone",
  "block.minecraft.emerald_ore": "emerald ore",
  "block.minecraft.ender_chest": "weelka ender",
  "block.minecraft.tripwire_hook": "hook tripwireka",
  "block.minecraft.emerald_block": "block of emerald",
  "block.minecraft.spruce_stairs": "dhir jaranjaro",
  "block.minecraft.birch_stairs": "bjørk jaranjaro",
  "block.minecraft.jungle_stairs": "duurjoogta jaranjaro",
  "block.minecraft.crimson_stairs": "jaranjarooyinka dulmiga ah",
  "block.minecraft.warped_stairs": "jaranjarooyinka fudud",
  "block.minecraft.command_block": "lebenkii amarka",
  "block.minecraft.beacon": "iftiinka",
  "block.minecraft.cobblestone_wall": "gidaarka dhagaxa ah",
  "block.minecraft.mossy_cobblestone_wall": "darbiga dhagxaanta mossy",
  "block.minecraft.brick_wall": "derbiga lebbiska",
  "block.minecraft.prismarine_wall": "derbiga prismarine",
  "block.minecraft.red_sandstone_wall": "derbiga sandstone sanduuqa",
  "block.minecraft.mossy_stone_brick_wall": "derbiga lebiska dhagaxa ah",
  "block.minecraft.granite_wall": "derbiga granite",
  "block.minecraft.stone_brick_wall": "derbiga lebbiska",
  "block.minecraft.nether_brick_wall": "derbiga lebiska",
  "block.minecraft.andesite_wall": "derbiga iyo weelka",
  "block.minecraft.red_nether_brick_wall": "derbiga lebiska cas",
  "block.minecraft.sandstone_wall": "derbiga dhagax ciid",
  "block.minecraft.end_stone_brick_wall": "dheji derbiga lebbiska dhagaxa",
  "block.minecraft.diorite_wall": "derbiga diorite",
  "block.minecraft.blackstone_wall": "darbiga madoow",
  "block.minecraft.polished_blackstone_wall": "darbiga dhagaxa ah ee madoow",
  "block.minecraft.polished_blackstone_brick_wall": "darbiga madoow ee dhagaxa ah",
  "block.minecraft.stone_button": "badhanka dhagaxa",
  "block.minecraft.oak_button": "badhanka oak",
  "block.minecraft.spruce_button": "spruce badhanka",
  "block.minecraft.birch_button": "geedka birch badhanka",
  "block.minecraft.jungle_button": "geedaha kuleylaha badhanka",
  "block.minecraft.acacia_button": "badhanka acacia",
  "block.minecraft.dark_oak_button": "badhanka oak madow",
  "block.minecraft.crimson_button": "jaranjarooyinka dulmiga ah",
  "block.minecraft.warped_button": "badhanka dagaalka",
  "block.minecraft.polished_blackstone_button": "bambada madow ee la nuujiyey",
  "block.minecraft.anvil": "anvil",
  "block.minecraft.chipped_anvil": "xanrunta jaban",
  "block.minecraft.damaged_anvil": "xudun yar oo jabtay",
  "block.minecraft.trapped_chest": "dabin sanduuq",
  "block.minecraft.light_weighted_pressure_plate": "cadaadiska cadaadiska iftiiminta khafiifka ah",
  "block.minecraft.heavy_weighted_pressure_plate": "culayska cadaadiska culus",
  "block.minecraft.daylight_detector": "qalabka maalinlaha",
  "block.minecraft.redstone_block": "block of redstone",
  "block.minecraft.nether_quartz_ore": "jutchz",
  "block.minecraft.hopper": "miro hod lagu dhisan",
  "block.minecraft.chiseled_quartz_block": "chiseled xannibaadda quarterz",
  "block.minecraft.quartz_block": "xannibaadda quarterz",
  "block.minecraft.quartz_bricks": "nalalka quartz",
  "block.minecraft.quartz_pillar": "tilmaamaha rubuc",
  "block.minecraft.quartz_stairs": "jaranjarooyinka rubuc",
  "block.minecraft.activator_rail": "firfircoonaan biraha",
  "block.minecraft.dropper": "cajiin",
  "block.minecraft.white_terracotta": "ceramics cad",
  "block.minecraft.orange_terracotta": "ceramics oranji",
  "block.minecraft.magenta_terracotta": "ceramics magenta",
  "block.minecraft.light_blue_terracotta": "ceramics dhalaalaya buluug",
  "block.minecraft.yellow_terracotta": "ceramics jaalle ah",
  "block.minecraft.lime_terracotta": "ceramics lime",
  "block.minecraft.pink_terracotta": "ceramics casaan",
  "block.minecraft.gray_terracotta": "grey terracotta",
  "block.minecraft.light_gray_terracotta": "iftiimin gray terracotta",
  "block.minecraft.cyan_terracotta": "cyan terracotta",
  "block.minecraft.purple_terracotta": "purple terracotta",
  "block.minecraft.blue_terracotta": "ceramics buluug",
  "block.minecraft.brown_terracotta": "ceramics bunni",
  "block.minecraft.green_terracotta": "ceramics cagaaran",
  "block.minecraft.red_terracotta": "ceramics casaan",
  "block.minecraft.black_terracotta": "ceramics madow",
  "block.minecraft.barrier": "ooday",
  "block.minecraft.iron_trapdoor": "birch hatch",
  "block.minecraft.hay_block": "sheaf ee hay",
  "block.minecraft.white_carpet": "caddaan kaarbadka",
  "block.minecraft.orange_carpet": "orange kaarbadka",
  "block.minecraft.magenta_carpet": "magenta kaarbadka",
  "block.minecraft.light_blue_carpet": "light blue kaarbadka",
  "block.minecraft.yellow_carpet": "yellow kaarbadka",
  "block.minecraft.lime_carpet": "lime kaarbadka",
  "block.minecraft.pink_carpet": "pink kaarbadka",
  "block.minecraft.gray_carpet": "gray kaarbadka",
  "block.minecraft.light_gray_carpet": "light gray kaarbadka",
  "block.minecraft.cyan_carpet": "cyan kaarbadka",
  "block.minecraft.purple_carpet": "purple kaarbadka",
  "block.minecraft.blue_carpet": "blue kaarbadka",
  "block.minecraft.brown_carpet": "brown kaarbadka",
  "block.minecraft.green_carpet": "green kaarbadka",
  "block.minecraft.red_carpet": "red kaarbadka",
  "block.minecraft.black_carpet": "black kaarbadka",
  "block.minecraft.terracotta": "ceramics",
  "block.minecraft.coal_block": "dhuxusha dhuxusha",
  "block.minecraft.packed_ice": "ice buuxiyey",
  "block.minecraft.acacia_stairs": "qudhac ah jaranjaro",
  "block.minecraft.dark_oak_stairs": "madow dhuxusha jaranjaro",
  "block.minecraft.slime_block": "xannibaadda slime",
  "block.minecraft.grass_path": "jid",
  "block.minecraft.sunflower": "gabbaldayaha",
  "block.minecraft.lilac": "lilac",
  "block.minecraft.rose_bush": "cawska casaan",
  "block.minecraft.peony": "peony",
  "block.minecraft.tall_grass": "cows dheer",
  "block.minecraft.large_fern": "ferning fern",
  "block.minecraft.white_stained_glass": "white wasakheeyey glass",
  "block.minecraft.orange_stained_glass": "orange wasakheeyey glass",
  "block.minecraft.magenta_stained_glass": "magenta wasakheeyey glass",
  "block.minecraft.light_blue_stained_glass": "light blue wasakheeyey glass",
  "block.minecraft.yellow_stained_glass": "yellow wasakheeyey glass",
  "block.minecraft.lime_stained_glass": "lime wasakheeyey glass",
  "block.minecraft.pink_stained_glass": "pink wasakheeyey glass",
  "block.minecraft.gray_stained_glass": "gray wasakheeyey glass",
  "block.minecraft.light_gray_stained_glass": "light gray wasakheeyey glass",
  "block.minecraft.cyan_stained_glass": "cyan wasakheeyey glass",
  "block.minecraft.purple_stained_glass": "purple wasakheeyey glass",
  "block.minecraft.blue_stained_glass": "blue wasakheeyey glass",
  "block.minecraft.brown_stained_glass": "brown wasakheeyey glass",
  "block.minecraft.green_stained_glass": "green wasakheeyey glass",
  "block.minecraft.red_stained_glass": "red wasakheeyey glass",
  "block.minecraft.black_stained_glass": "black wasakheeyey glass",
  "block.minecraft.white_stained_glass_pane": "white wasakheeyey murayaad",
  "block.minecraft.orange_stained_glass_pane": "orange wasakheeyey murayaad",
  "block.minecraft.magenta_stained_glass_pane": "magenta wasakheeyey murayaad",
  "block.minecraft.light_blue_stained_glass_pane": "light blue wasakheeyey murayaad",
  "block.minecraft.yellow_stained_glass_pane": "yellow wasakheeyey murayaad",
  "block.minecraft.lime_stained_glass_pane": "lime wasakheeyey murayaad",
  "block.minecraft.pink_stained_glass_pane": "pink wasakheeyey murayaad",
  "block.minecraft.gray_stained_glass_pane": "gray wasakheeyey murayaad",
  "block.minecraft.light_gray_stained_glass_pane": "light gray wasakheeyey murayaad",
  "block.minecraft.cyan_stained_glass_pane": "cyan wasakheeyey murayaad",
  "block.minecraft.purple_stained_glass_pane": "purple wasakheeyey murayaad",
  "block.minecraft.blue_stained_glass_pane": "blue wasakheeyey murayaad",
  "block.minecraft.brown_stained_glass_pane": "brown wasakheeyey murayaad",
  "block.minecraft.green_stained_glass_pane": "green wasakheeyey murayaad",
  "block.minecraft.red_stained_glass_pane": "red wasakheeyey murayaad",
  "block.minecraft.black_stained_glass_pane": "black wasakheeyey murayaad",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "prismarine lebbiska xargaha",
  "block.minecraft.dark_prismarine": "maskax madoobaadka",
  "block.minecraft.prismarine_stairs": "jaranjarada prismarine",
  "block.minecraft.prismarine_brick_stairs": "prismarine lebbiska jaranjaro",
  "block.minecraft.dark_prismarine_stairs": "jaranjarada prismarine jaranjarada",
  "block.minecraft.sea_lantern": "badda faynuus",
  "block.minecraft.red_sandstone": "casaan sandstone",
  "block.minecraft.chiseled_red_sandstone": "qoray red sandstone",
  "block.minecraft.cut_red_sandstone": "iska yaree sanduuqa casaanka ah",
  "block.minecraft.red_sandstone_stairs": "jaranjarooyinka cas ee dhagaxa ah",
  "block.minecraft.repeating_command_block": "ku celcelinta leben amarka",
  "block.minecraft.chain_command_block": "ku celcelinta leben amarka",
  "block.minecraft.magma_block": "dhagaxa block",
  "block.minecraft.nether_wart_block": "kala soco wart block",
  "block.minecraft.warped_wart_block": "kala soco wart block",
  "block.minecraft.red_nether_bricks": "casaan dhalaalaysa",
  "block.minecraft.bone_block": "laf block",
  "block.minecraft.structure_void": "qaab dhismeed madhan",
  "block.minecraft.observer": "fiirso",
  "block.minecraft.shulker_box": "sanduuqa sholle",
  "block.minecraft.white_shulker_box": "sanduuqa white shulle",
  "block.minecraft.orange_shulker_box": "sanduuqa shalker oranji",
  "block.minecraft.magenta_shulker_box": "magenta shuller sanduuqa",
  "block.minecraft.light_blue_shulker_box": "sanduuqa shalker buluug ah oo fudud",
  "block.minecraft.yellow_shulker_box": "sanduuqa shalker jaalaha ah",
  "block.minecraft.lime_shulker_box": "sanduuqa lime sholker",
  "block.minecraft.pink_shulker_box": "sanduuqa shalker pink",
  "block.minecraft.gray_shulker_box": "sanduuqa cawlan",
  "block.minecraft.light_gray_shulker_box": "sanduuqa shuck schker fudud",
  "block.minecraft.cyan_shulker_box": "sanduuqa crancan shulker",
  "block.minecraft.purple_shulker_box": "sanduuqa shuckper",
  "block.minecraft.blue_shulker_box": "sanduuqa shalker buluug",
  "block.minecraft.brown_shulker_box": "sanduuqa shaleefka bunni",
  "block.minecraft.green_shulker_box": "sanduuqa cagaaran",
  "block.minecraft.red_shulker_box": "sanduuqa red sholker",
  "block.minecraft.black_shulker_box": "sanduuqa madow ee madow",
  "block.minecraft.white_glazed_terracotta": "cadcad cad oo loo yaqaan terracotta",
  "block.minecraft.orange_glazed_terracotta": "oranji glazed terracotta",
  "block.minecraft.magenta_glazed_terracotta": "cadcad cad oo loo yaqaan terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "blass buluug iftiin leh oo buluug ah",
  "block.minecraft.yellow_glazed_terracotta": "huruud huruud ah oo huruud ah",
  "block.minecraft.lime_glazed_terracotta": "cadcad cad oo loo yaqaan terracotta",
  "block.minecraft.pink_glazed_terracotta": "casaan dhalaalaya terracotta",
  "block.minecraft.gray_glazed_terracotta": "oranji glazed terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "grod fer tracotta",
  "block.minecraft.cyan_glazed_terracotta": "cran glazed terracotta",
  "block.minecraft.purple_glazed_terracotta": "buluug gropled terracotta",
  "block.minecraft.blue_glazed_terracotta": "buluug glazed terracotta",
  "block.minecraft.brown_glazed_terracotta": "bunni madxafka terracotta",
  "block.minecraft.green_glazed_terracotta": "grown glazed terracotta",
  "block.minecraft.red_glazed_terracotta": "casaan madxafka terracotta",
  "block.minecraft.black_glazed_terracotta": "madow madxafka terracotta",
  "block.minecraft.white_concrete": "caddaan la taaban karo",
  "block.minecraft.orange_concrete": "la taaban karo oranji",
  "block.minecraft.magenta_concrete": "basalicarwaajis la taaban karo",
  "block.minecraft.light_blue_concrete": "buluug buluug ah oo fudud",
  "block.minecraft.yellow_concrete": "jaalle la taaban karo",
  "block.minecraft.lime_concrete": "akhtar cagaaran la taaban karo too",
  "block.minecraft.pink_concrete": "basali la taaban karo",
  "block.minecraft.gray_concrete": "la taaban karo",
  "block.minecraft.light_gray_concrete": "iftiiminta cawlan",
  "block.minecraft.cyan_concrete": "cury la taaban karo",
  "block.minecraft.purple_concrete": "si la taaban karo oo la taaban karo",
  "block.minecraft.blue_concrete": "buluug la taaban karo",
  "block.minecraft.brown_concrete": "bunni la taaban karo",
  "block.minecraft.green_concrete": "cagaaran la taaban karo",
  "block.minecraft.red_concrete": "la taaban karo",
  "block.minecraft.black_concrete": "madow la taaban karo",
  "block.minecraft.white_concrete_powder": "caddaan budada la taaban karo",
  "block.minecraft.orange_concrete_powder": "liimi budada la taaban karo",
  "block.minecraft.magenta_concrete_powder": "basalicarwaajis budada la taaban karo",
  "block.minecraft.light_blue_concrete_powder": "iftiin buluug budada la taaban karo",
  "block.minecraft.yellow_concrete_powder": "jaalle budada la taaban karo",
  "block.minecraft.lime_concrete_powder": "akhtar budada la taaban karo",
  "block.minecraft.pink_concrete_powder": "basali budada la taaban karo",
  "block.minecraft.gray_concrete_powder": "dameeri budada la taaban karo",
  "block.minecraft.light_gray_concrete_powder": "iftiin dameeri budada la taaban karo",
  "block.minecraft.cyan_concrete_powder": "cyan budada la taaban karo",
  "block.minecraft.purple_concrete_powder": "carwaajis budada la taaban karo",
  "block.minecraft.blue_concrete_powder": "buulug la taaban karo budada",
  "block.minecraft.brown_concrete_powder": "bunni budada la taaban karo",
  "block.minecraft.green_concrete_powder": "cagaar budada la taaban karo",
  "block.minecraft.red_concrete_powder": "casaan budada la taaban karo",
  "block.minecraft.black_concrete_powder": "madow budada la taaban karo",
  "block.minecraft.turtle_egg": "ukunta dixirka",
  "block.minecraft.dead_tube_coral_block": "tube dhintay coral block",
  "block.minecraft.dead_brain_coral_block": "dhimashada maskaxda maskaxda maskaxda",
  "block.minecraft.dead_bubble_coral_block": "coral xumbo dhintay xannibaad",
  "block.minecraft.dead_fire_coral_block": "dhuxul dabka dhimatay xannibaad",
  "block.minecraft.dead_horn_coral_block": "dhimashada coral hom xannibaad",
  "block.minecraft.tube_coral_block": "tube coral block",
  "block.minecraft.brain_coral_block": "block coral block",
  "block.minecraft.bubble_coral_block": "xumbo coral block",
  "block.minecraft.fire_coral_block": "dab-damiska dab_damiska",
  "block.minecraft.horn_coral_block": "xayndaabka geeska",
  "block.minecraft.tube_coral": "tube coral",
  "block.minecraft.brain_coral": "maskaxda corta",
  "block.minecraft.bubble_coral": "coral xumbo",
  "block.minecraft.fire_coral": "dhuxul dabka",
  "block.minecraft.horn_coral": "horn coral",
  "block.minecraft.dead_brain_coral": "coral maskaxda dhintay",
  "block.minecraft.dead_bubble_coral": "coral xumbo dhintay",
  "block.minecraft.dead_fire_coral": "dhuxul dabka dhimatay",
  "block.minecraft.dead_horn_coral": "coralhorn dhintay",
  "block.minecraft.dead_tube_coral": "coral tube dhintay",
  "block.minecraft.tube_coral_fan": "tube coral fan",
  "block.minecraft.brain_coral_fan": "fanaanka coral maskaxda",
  "block.minecraft.bubble_coral_fan": "8 fan xumbo coral",
  "block.minecraft.fire_coral_fan": "fanaanka xidigaha geeska",
  "block.minecraft.horn_coral_fan": "fanaanka xidigaha geeska",
  "block.minecraft.dead_tube_coral_fan": "tube dhintay coral fan",
  "block.minecraft.dead_brain_coral_fan": "fankii coral maskaxda dhintay",
  "block.minecraft.dead_bubble_coral_fan": "fan xumbo coral fan",
  "block.minecraft.dead_fire_coral_fan": "fanaanka dabka dhimatay",
  "block.minecraft.dead_horn_coral_fan": "fanaanka geeska geeska dhintay",
  "block.minecraft.blue_ice": "baraf buluug ah",
  "block.minecraft.conduit": "biyomareenka",
  "block.minecraft.polished_granite_stairs": "jaranjaro granite leh",
  "block.minecraft.smooth_red_sandstone_stairs": "jaranjarada sandstone dhagax casaan leh",
  "block.minecraft.mossy_stone_brick_stairs": "jaranjarooyinka lebiska dhagaxa ah",
  "block.minecraft.polished_diorite_stairs": "daboolka diorite ee dhalaalaya",
  "block.minecraft.mossy_cobblestone_stairs": "jaranjarooyinka mossy",
  "block.minecraft.end_stone_brick_stairs": "joojiya jaranjarada lebenka dhagaxa",
  "block.minecraft.stone_stairs": "jaranjarada dhagaxa",
  "block.minecraft.smooth_sandstone_stairs": "jaranjarada sandstone siman",
  "block.minecraft.smooth_quartz_stairs": "jaranjarada quartz oo siman",
  "block.minecraft.granite_stairs": "jaranjarada granite",
  "block.minecraft.andesite_stairs": "jaranjaro iyo jaranjaro",
  "block.minecraft.red_nether_brick_stairs": "jaranjarooyinka lebiska cas",
  "block.minecraft.polished_andesite_stairs": "jaranjarooyinka laysku qurxiyo",
  "block.minecraft.diorite_stairs": "jaranjarada diorite",
  "block.minecraft.polished_granite_slab": "daboolan cajalad leh",
  "block.minecraft.smooth_red_sandstone_slab": "daboolka sanduuqa cas ee casaanka ah",
  "block.minecraft.mossy_stone_brick_slab": "lebbiska dhagxaanta dhagaxa ah",
  "block.minecraft.polished_diorite_slab": "daboolka diorite ee dhalaalaya",
  "block.minecraft.mossy_cobblestone_slab": "mossy cottonblestone slab",
  "block.minecraft.end_stone_brick_slab": "soo afjaro lebbiska dhagxaanta",
  "block.minecraft.smooth_sandstone_slab": "sanduuqa dhagaxa sanduuqa ah",
  "block.minecraft.smooth_quartz_slab": "gogol xajin ah",
  "block.minecraft.granite_slab": "boorashka granite",
  "block.minecraft.andesite_slab": "weelka iyo weelka",
  "block.minecraft.red_nether_brick_slab": "lebbiska casaanka cas",
  "block.minecraft.polished_andesite_slab": "daboolan oo laysku qurxiyo",
  "block.minecraft.diorite_slab": "qolka diorite",
  "block.minecraft.scaffolding": "xayiraad",
  "block.minecraft.iron_door": "albaab bir ah",
  "block.minecraft.oak_door": "oak albaabka",
  "block.minecraft.spruce_door": "dhir albaabka",
  "block.minecraft.birch_door": "albaabka boodhka",
  "block.minecraft.jungle_door": "jungle albaabka",
  "block.minecraft.acacia_door": "acacia albaabka",
  "block.minecraft.dark_oak_door": "madow oak albaabka",
  "block.minecraft.crimson_door": "albaabka dambiilaha",
  "block.minecraft.warped_door": "warped door",
  "block.minecraft.repeater": "dhagaxa cas ee soo noqnoqda",
  "block.minecraft.comparator": "is barbar dhig dhagax cas",
  "block.minecraft.structure_block": "block block",
  "block.minecraft.jigsaw": "xujo jigsaw",
  "item.minecraft.turtle_helmet": "qolof didiin□□markaad madaxa tahay:□+2 hubka",
  "item.minecraft.scute": "gaashaan",
  "item.minecraft.iron_shovel": "majarafad dhagax ah□□markaad ku jirto gacanta ugu muhiimsan:□+3.5 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.iron_pickaxe": "burska birtah□□markaad ku jirto gacanta ugu muhiimsan:□+3 burburka weerarka□-2.8 xawaaraha weerarka",
  "item.minecraft.iron_axe": "misarta birtah□□markaad ku jirto gacanta ugu muhiimsan:□+8 burburka weerarka□-3.1 xawaaraha weerarka",
  "item.minecraft.flint_and_steel": "flint iyo biraha",
  "item.minecraft.apple": "tufaax",
  "item.minecraft.bow": "qaansada",
  "item.minecraft.arrow": "filaar",
  "item.minecraft.coal": "dhuxul",
  "item.minecraft.charcoal": "dhuxul dhagax",
  "item.minecraft.diamond": "dheeman",
  "item.minecraft.iron_ingot": "bir -gelinta",
  "item.minecraft.gold_ingot": "bar dahab ah",
  "item.minecraft.netherite_ingot": "netherite ingot",
  "item.minecraft.netherite_scrap": "xadhiga netherite",
  "item.minecraft.iron_sword": "seefto birta□□markaad ku jirto gacanta ugu muhiimsan:□+5 burburka weerarka□-2.4 xawaaraha weerarka",
  "item.minecraft.wooden_sword": "seef alwaax ah□□markaad ku jirto gacanta ugu muhiimsan:□+3 burburka weerarka□-2.4 xawaaraha weerarka",
  "item.minecraft.wooden_shovel": "majarafad alwaax ah□□markaad ku jirto gacanta ugu muhiimsan:□+1.5 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.wooden_pickaxe": "alwaax alwaax ah□□markaad ku jirto gacanta ugu muhiimsan:□+1 burburka weerarka□-2.8 xawaaraha weerarka",
  "item.minecraft.wooden_axe": "alwaax alwaax ah□□markaad ku jirto gacanta ugu muhiimsan:□+6 burburka weerarka□-3.2 xawaaraha weerarka",
  "item.minecraft.stone_sword": "seefta dhagax□□markaad ku jirto gacanta ugu muhiimsan:□+4 burburka weerarka□-2.4 xawaaraha weerarka",
  "item.minecraft.stone_shovel": "majarafad dhagax ah□□markaad ku jirto gacanta ugu muhiimsan:□+2.5 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.stone_pickaxe": "dhagax ka qaatay□□markaad ku jirto gacanta ugu muhiimsan:□+2 burburka weerarka□-2.8 xawaaraha weerarka",
  "item.minecraft.stone_axe": "fan dhagxan□□markaad ku jirto gacanta ugu muhiimsan:□+8 burburka weerarka□-3.2 xawaaraha weerarka",
  "item.minecraft.diamond_sword": "seefta damaymakah□□markaad ku jirto gacanta ugu muhiimsan:□+6 burburka weerarka□-2.4 xawaaraha weerarka",
  "item.minecraft.diamond_shovel": "badiilka damaymakah□□markaad ku jirto gacanta ugu muhiimsan:□+4.5 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.diamond_pickaxe": "burska damaymakah□□markaad ku jirto gacanta ugu muhiimsan:□+4 burburka weerarka□-2.8 xawaaraha weerarka",
  "item.minecraft.diamond_axe": "misarta damaymakah□□markaad ku jirto gacanta ugu muhiimsan:□+8 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.stick": "oul",
  "item.minecraft.bowl": "baqulo",
  "item.minecraft.mushroom_stew": "lugta likaha",
  "item.minecraft.golden_sword": "seefta dahbakah□□markaad ku jirto gacanta ugu muhiimsan:□+3 burburka weerarka□-2.4 xawaaraha weerarka",
  "item.minecraft.golden_shovel": "badiilka dahbakah□□markaad ku jirto gacanta ugu muhiimsan:□+1.5 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.golden_pickaxe": "dahab dahab ah□□markaad ku jirto gacanta ugu muhiimsan:□+1 burburka weerarka□-2.8 xawaaraha weerarka",
  "item.minecraft.golden_axe": "farta dahabka□□markaad ku jirto gacanta ugu muhiimsan:□+6 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.netherite_sword": "seefta netherite□□markaad ku jirto gacanta ugu muhiimsan:□+7 burburka weerarka□-2.4 xawaaraha weerarka",
  "item.minecraft.netherite_shovel": "shoobaalka netherite□□markaad ku jirto gacanta ugu muhiimsan:□+5.5 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.netherite_pickaxe": "netherite pickaxe□□markaad ku jirto gacanta ugu muhiimsan:□+5 burburka weerarka□-2.8 xawaaraha weerarka",
  "item.minecraft.netherite_axe": "axmaarada ax□□markaad ku jirto gacanta ugu muhiimsan:□+9 burburka weerarka□-3 xawaaraha weerarka",
  "item.minecraft.string": "xadhig",
  "item.minecraft.feather": "baal",
  "item.minecraft.gunpowder": "gunpowyder",
  "item.minecraft.wooden_hoe": "alwaax hoe□□markaad ku jirto gacanta ugu muhiimsan:□-3 xawaaraha weerarka",
  "item.minecraft.stone_hoe": "dhagax adag□□markaad ku jirto gacanta ugu muhiimsan:□-2 xawaaraha weerarka",
  "item.minecraft.iron_hoe": "bir hoe□□markaad ku jirto gacanta ugu muhiimsan:□-1 xawaaraha weerarka",
  "item.minecraft.diamond_hoe": "dheeman hoe□□markaad ku jirto gacanta ugu muhiimsan:",
  "item.minecraft.golden_hoe": "farta dahabka□□markaad ku jirto gacanta ugu muhiimsan:□-3 xawaaraha weerarka",
  "item.minecraft.netherite_hoe": "netherite hoe□□markaad ku jirto gacanta ugu muhiimsan:",
  "item.minecraft.wheat_seeds": "badbaadiyaha",
  "item.minecraft.wheat": "qamadi",
  "item.minecraft.bread": "kibistii",
  "item.minecraft.leather_helmet": "daboolka maqaarka□□markaad madaxa tahay:□+1 hubka",
  "item.minecraft.leather_chestplate": "dharka maqaarka□□markaad joogto:□+3 hubka",
  "item.minecraft.leather_leggings": "surwaalka hargaha□□markay lugaha tahay:□+2 hubka",
  "item.minecraft.leather_boots": "kabaha hargaha□□markaad caga dhiganeyso:□+1 hubka",
  "item.minecraft.chainmail_helmet": "koofiyadda chainmail□□markaad madaxa tahay:□+2 hubka",
  "item.minecraft.chainmail_chestplate": "shaxda cheinmail□□markaad joogto:□+5 hubka",
  "item.minecraft.chainmail_leggings": "silsilad lugaha□□markay lugaha tahay:□+4 hubka",
  "item.minecraft.chainmail_boots": "kabaha chainmail□□markaad caga dhiganeyso:□+1 hubka",
  "item.minecraft.iron_helmet": "koofiyadda birta□□markaad madaxa tahay:□+2 hubka",
  "item.minecraft.iron_chestplate": "xabadka birta□□markaad joogto:□+6 hubka",
  "item.minecraft.iron_leggings": "lugaha birta□□markay lugaha tahay:□+5 hubka",
  "item.minecraft.iron_boots": "kabaha birta□□markaad caga dhiganeyso:□+2 hubka",
  "item.minecraft.diamond_helmet": "koofiyadda dheemanka□□markaad madaxa tahay:□+3 hubka□+2 adkaynta hubka",
  "item.minecraft.diamond_chestplate": "dheemanka dheeman□□markaad joogto:□+8 hubka□+2 adkaynta hubka",
  "item.minecraft.diamond_leggings": "lugeynta dheemanka□□markay lugaha tahay:□+6 hubka□+2 adkaynta hubka",
  "item.minecraft.diamond_boots": "kabaha dheeman□□markaad caga dhiganeyso:□+3 hubka□+2 adkaynta hubka",
  "item.minecraft.golden_helmet": "koofiyad dahab ah□□markaad madaxa tahay:□+2 hubka",
  "item.minecraft.golden_chestplate": "chebtplate dahab ah□□markaad joogto:□+5 hubka",
  "item.minecraft.golden_leggings": "gogol dahab ah□□markay lugaha tahay:□+3 hubka",
  "item.minecraft.golden_boots": "kabaha dahabka ah□□markaad caga dhiganeyso:□+1 hubka",
  "item.minecraft.netherite_helmet": "netherite ingot□□markaad madaxa tahay:□+3 hubka□+3 adkaynta hubka□+1 iska caabinta dhabarka",
  "item.minecraft.netherite_chestplate": "chestplate loo yaqaan 'netherite chestplate'□□markaad joogto:□+8 hubka□+3 adkaynta hubka□+1 iska caabinta dhabarka",
  "item.minecraft.netherite_leggings": "legitings netherite□□markay lugaha tahay:□+6 hubka□+3 adkaynta hubka□+1 iska caabinta dhabarka",
  "item.minecraft.netherite_boots": "boorsooyinka netherite□□markaad caga dhiganeyso:□+3 hubka□+3 adkaynta hubka□+1 iska caabinta dhabarka",
  "item.minecraft.flint": "dhagaxaan",
  "item.minecraft.porkchop": "porkchop ceeriin ah",
  "item.minecraft.cooked_porkchop": "porkchop la kariyey",
  "item.minecraft.painting": "rinjiyeyn",
  "item.minecraft.golden_apple": "tufaax dahab ah",
  "item.minecraft.enchanted_golden_apple": "tufaax dahab ah oo la sixray",
  "block.minecraft.oak_sign": "calaamadda maqalka",
  "block.minecraft.spruce_sign": "dhir saxiix",
  "block.minecraft.birch_sign": "saxiix bjørk",
  "block.minecraft.jungle_sign": "duurjoogta saxiix",
  "block.minecraft.acacia_sign": "acacia saxiix",
  "block.minecraft.dark_oak_sign": "dhirta madow saxiix",
  "block.minecraft.crimson_sign": "calaamadda cas",
  "block.minecraft.warped_sign": "saxeex dagaal",
  "item.minecraft.bucket": "baaldi",
  "item.minecraft.water_bucket": "baaldi biyo ah",
  "item.minecraft.lava_bucket": "baldi dabha",
  "item.minecraft.minecart": "rimor",
  "item.minecraft.saddle": "kursi",
  "item.minecraft.redstone": "boorka redstone",
  "item.minecraft.snowball": "kubada barafk",
  "item.minecraft.oak_boat": "geed doon",
  "item.minecraft.leather": "maqaar",
  "item.minecraft.milk_bucket": "baaldi caano ah",
  "item.minecraft.pufferfish_bucket": "baaldiga pufferfish",
  "item.minecraft.salmon_bucket": "baaldi salmon ah",
  "item.minecraft.cod_bucket": "baaldi cod",
  "item.minecraft.tropical_fish_bucket": "baaldiga kalluunka kulaylaha",
  "item.minecraft.brick": "leben",
  "item.minecraft.clay_ball": "dhoobo kubadda",
  "block.minecraft.dried_kelp_block": "kelp qalalan",
  "item.minecraft.paper": "waraaq",
  "item.minecraft.book": "buug",
  "item.minecraft.slime_ball": "kubad kubbad",
  "item.minecraft.chest_minecart": "minecart oo leh laab",
  "item.minecraft.furnace_minecart": "minecart oo leh foorno",
  "item.minecraft.egg": "ukun",
  "item.minecraft.compass": "diirad",
  "item.minecraft.fishing_rod": "usha kalluumeysiga",
  "item.minecraft.clock": "saacad",
  "item.minecraft.glowstone_dust": "boodhka dhalaalaya",
  "item.minecraft.cod": "codka cagaaran",
  "item.minecraft.salmon": "clonn clon",
  "item.minecraft.tropical_fish": "kalluunka kuleylka ah",
  "item.minecraft.pufferfish": "burfunshish",
  "item.minecraft.cooked_cod": "codka la kariyey",
  "item.minecraft.cooked_salmon": "salmon la kariyey",
  "item.minecraft.ink_sac": "kiishad qad ah",
  "item.minecraft.red_dye": "dheeha cas",
  "item.minecraft.green_dye": "dheeh cagaaran",
  "item.minecraft.cocoa_beans": "bun",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "dheedka buluuga ah",
  "item.minecraft.cyan_dye": "cyran dheeh dheeh",
  "item.minecraft.light_gray_dye": "dheeh casaan ah",
  "item.minecraft.gray_dye": "midabada cawlan",
  "item.minecraft.pink_dye": "dheeh casaan",
  "item.minecraft.lime_dye": "dheeh dheeh",
  "item.minecraft.yellow_dye": "dheeha jaalaha ah",
  "item.minecraft.light_blue_dye": "dhogorta dhalaalaya buluug",
  "item.minecraft.magenta_dye": "magenta dheef",
  "item.minecraft.orange_dye": "dheeh oranji",
  "item.minecraft.bone_meal": "cuntada lafaha",
  "item.minecraft.blue_dye": "dheeh buluug ah",
  "item.minecraft.brown_dye": "dheeha madow",
  "item.minecraft.black_dye": "dheeha madow",
  "item.minecraft.white_dye": "dheeha cad",
  "item.minecraft.bone": "lafaha",
  "item.minecraft.sugar": "sonkorta",
  "block.minecraft.cake": "cake",
  "block.minecraft.white_bed": "sariir cad",
  "block.minecraft.orange_bed": "sariir burtiqaal",
  "block.minecraft.magenta_bed": "sariir magenta",
  "block.minecraft.light_blue_bed": "sariir qafiif buluug",
  "block.minecraft.yellow_bed": "sariir jaalo",
  "block.minecraft.lime_bed": "sariir lime",
  "block.minecraft.pink_bed": "sariir basaly",
  "block.minecraft.gray_bed": "sariir rasaasi",
  "block.minecraft.light_gray_bed": "sariir cawlan oo fudud",
  "block.minecraft.cyan_bed": "sariirta cran",
  "block.minecraft.purple_bed": "sariir guduudan",
  "block.minecraft.blue_bed": "sariirta buluugga ah",
  "block.minecraft.brown_bed": "sariirta brown",
  "block.minecraft.green_bed": "sariir cagaaran",
  "block.minecraft.red_bed": "sariirta gaduudan",
  "block.minecraft.black_bed": "sariirta madow",
  "item.minecraft.cookie": "buskut",
  "item.minecraft.filled_map": "khariidad□#0",
  "item.minecraft.shears": "maqas",
  "item.minecraft.melon_slice": "qalab dhoobo",
  "item.minecraft.dried_kelp": "balsi qalalan",
  "item.minecraft.pumpkin_seeds": "abuurka bocorka",
  "item.minecraft.melon_seeds": "abuurka qaraha",
  "item.minecraft.beef": "hiib lo cayriin",
  "item.minecraft.cooked_beef": "isteek",
  "item.minecraft.chicken": "digaag cayriin",
  "item.minecraft.cooked_chicken": "digaag lakariyey",
  "item.minecraft.rotten_flesh": "hilib qurmay",
  "item.minecraft.ender_pearl": "ender luul",
  "item.minecraft.blaze_rod": "oul oloeyes",
  "item.minecraft.ghast_tear": "ilmo qosol",
  "item.minecraft.gold_nugget": "xabbad dahab",
  "item.minecraft.nether_wart": "hoose burto",
  "item.minecraft.potion": "qalab aan la farsamayn karin□saamayn la'aan",
  "item.minecraft.glass_bottle": "dhalada ugadamabeysa",
  "item.minecraft.spider_eye": "isha carada",
  "item.minecraft.fermented_spider_eye": "isha caaro khamiirsan",
  "item.minecraft.blaze_powder": "budada ololaysa",
  "item.minecraft.magma_cream": "magma creme",
  "block.minecraft.brewing_stand": "istaag taagan",
  "block.minecraft.cauldron": "kuleylka",
  "item.minecraft.ender_eye": "indhaha dhamaadka",
  "item.minecraft.glistering_melon_slice": "qaraha xarkaha qaraha",
  "item.minecraft.bat_spawn_egg": "bisad ku dhalatay ukunta",
  "item.minecraft.bee_spawn_egg": "shinni spawn ukunta",
  "item.minecraft.blaze_spawn_egg": "shinni spawn ukunta",
  "item.minecraft.cat_spawn_egg": "bisad ku dhalatay ukunta",
  "item.minecraft.cave_spider_spawn_egg": "cadaadiska cagaaran ukunta spawn",
  "item.minecraft.chicken_spawn_egg": "ukunta digaagga",
  "item.minecraft.cod_spawn_egg": "bisad ku dhalatay ukunta",
  "item.minecraft.cow_spawn_egg": "bisad ku dhalatay ukunta",
  "item.minecraft.creeper_spawn_egg": "cadaadiska cagaaran ukunta spawn",
  "item.minecraft.dolphin_spawn_egg": "zoglin spawn egg",
  "item.minecraft.donkey_spawn_egg": "dameer ukunta",
  "item.minecraft.drowned_spawn_egg": "ukun u dhinta ukunta",
  "item.minecraft.elder_guardian_spawn_egg": "magangelyo oday ah ukunta",
  "item.minecraft.enderman_spawn_egg": "ukunta enderman",
  "item.minecraft.endermite_spawn_egg": "ukunta u dhinta ukunta",
  "item.minecraft.evoker_spawn_egg": "evoker dhalin ukun",
  "item.minecraft.fox_spawn_egg": "dawaco wuxuu dhaley ukun",
  "item.minecraft.ghast_spawn_egg": "ukunta xamaasada leh",
  "item.minecraft.guardian_spawn_egg": "ilaaliyaha ukunta dhalin",
  "item.minecraft.hoglin_spawn_egg": "hoglin spawn egg",
  "item.minecraft.horse_spawn_egg": "faras wuxuu dhaley ukun",
  "item.minecraft.husk_spawn_egg": "xusuusnow ukun dhalin",
  "item.minecraft.llama_spawn_egg": "ari wuxuu dhaley ukun",
  "item.minecraft.magma_cube_spawn_egg": "magma cube ukun dhaley",
  "item.minecraft.mooshroom_spawn_egg": "ukun dhalo mooshroom",
  "item.minecraft.mule_spawn_egg": "baqal wuxuu dhaley ukun",
  "item.minecraft.ocelot_spawn_egg": "ocelot wuxuu dhaley ukun",
  "item.minecraft.panda_spawn_egg": "panda spawn ukunta",
  "item.minecraft.parrot_spawn_egg": "baqbaqaaq wuxuu dhaley ukun",
  "item.minecraft.phantom_spawn_egg": "phantom wuxuu dhaley ukun",
  "item.minecraft.pig_spawn_egg": "dofaarka wuxuu dhaley ukun",
  "item.minecraft.piglin_spawn_egg": "piglin spawn egg",
  "item.minecraft.pillager_spawn_egg": "pillager kalluunka ukun",
  "item.minecraft.polar_bear_spawn_egg": "ukunta taranka ee orso",
  "item.minecraft.pufferfish_spawn_egg": "kalluunka dufan ee ukunta taranka",
  "item.minecraft.rabbit_spawn_egg": "bakeyle wuhuu dhaley ukun",
  "item.minecraft.ravager_spawn_egg": "ravager ukun dhalo",
  "item.minecraft.salmon_spawn_egg": "jader wuxuu dhaley ukun",
  "item.minecraft.sheep_spawn_egg": "ido wuxuu dhaley ukun",
  "item.minecraft.shulker_spawn_egg": "shulker wuxuu dhaley ukun",
  "item.minecraft.silverfish_spawn_egg": "ukunta taranka ee kalluunka",
  "item.minecraft.skeleton_spawn_egg": "qolfaf wuxuu dhaley ukun",
  "item.minecraft.skeleton_horse_spawn_egg": "faraska qolfafkah wuxuu dhaley ukun",
  "item.minecraft.slime_spawn_egg": "slime wuxuu dhaley ukun",
  "item.minecraft.spider_spawn_egg": "aro wuxuu dhaley ukun",
  "item.minecraft.squid_spawn_egg": "ukunta taranka dabacasaha",
  "item.minecraft.stray_spawn_egg": "ukun dhalay oo dhumay",
  "item.minecraft.strider_spawn_egg": "strider spawn egg",
  "item.minecraft.trader_llama_spawn_egg": "baayacmushtarka llama ukunta dhaley",
  "item.minecraft.tropical_fish_spawn_egg": "kallunnka kulaylaha ah ayaa dhasha ukun",
  "item.minecraft.turtle_spawn_egg": "diniin wuxuu dhaley ukun",
  "item.minecraft.vex_spawn_egg": "vex wuxuu dhaley ukun",
  "item.minecraft.villager_spawn_egg": "pillager kalluunka ukun",
  "item.minecraft.vindicator_spawn_egg": "tuugta ukunta taranka",
  "item.minecraft.wandering_trader_spawn_egg": "ganacsadaha warwareega ayaa ukun dhalay",
  "item.minecraft.witch_spawn_egg": "saxirad wuxuu dhaley ukun",
  "item.minecraft.wither_skeleton_spawn_egg": "ukun taranka qallafsan",
  "item.minecraft.wolf_spawn_egg": "yeey wuxuu dhaley ukun",
  "item.minecraft.zoglin_spawn_egg": "zoglin spawn egg",
  "item.minecraft.zombie_spawn_egg": "zombie wuxuu dhaley ukun",
  "item.minecraft.zombie_horse_spawn_egg": "faraska zombie wuxuu dhaley ukun",
  "item.minecraft.zombie_villager_spawn_egg": "tuulada zombie ayaa dhalay ukun",
  "item.minecraft.zombified_piglin_spawn_egg": "zombified piglin spawn egg",
  "item.minecraft.experience_bottle": "dhalo lagu sixro",
  "item.minecraft.fire_charge": "kharashka dabka",
  "item.minecraft.writable_book": "buug iyo quill",
  "item.minecraft.written_book": "buug qorid",
  "item.minecraft.emerald": "samurud",
  "item.minecraft.item_frame": "qaabka shayga",
  "block.minecraft.flower_pot": "dheriga ubaxa",
  "item.minecraft.carrot": "karoto",
  "item.minecraft.potato": "baradho",
  "item.minecraft.baked_potato": "baradho la dubay",
  "item.minecraft.poisonous_potato": "baradho sunta leh",
  "item.minecraft.map": "khariidad madhan",
  "item.minecraft.golden_carrot": "karoto o dahabah",
  "block.minecraft.skeleton_skull": "qalfoofka skeleton",
  "block.minecraft.wither_skeleton_skull": "qalfoofka qalfoofka",
  "block.minecraft.player_head": "madaxa cayaaraha",
  "block.minecraft.zombie_head": "madaxa zombie",
  "block.minecraft.creeper_head": "madaxa creeper",
  "block.minecraft.dragon_head": "masduulaagii maxada",
  "item.minecraft.carrot_on_a_stick": "karootada usha",
  "item.minecraft.warped_fungus_on_a_stick": "furuut dillaacay on stick ah",
  "item.minecraft.nether_star": "xidig nether",
  "item.minecraft.pumpkin_pie": "shaambadaha",
  "item.minecraft.firework_rocket": "gantaalka rashka",
  "item.minecraft.firework_star": "xiddigta dab-damiska",
  "item.minecraft.enchanted_book": "buug la sixray",
  "item.minecraft.nether_brick": "birka nether",
  "item.minecraft.quartz": "nether quartz",
  "item.minecraft.tnt_minecart": "minecart oo leh tnt",
  "item.minecraft.hopper_minecart": "minecart oo leh hopper",
  "item.minecraft.prismarine_shard": "prismarine shard",
  "item.minecraft.prismarine_crystals": "kiristaalo prismarine ah",
  "item.minecraft.rabbit": "bakeylhe cayriin",
  "item.minecraft.cooked_rabbit": "bakeylhe lkarey",
  "item.minecraft.rabbit_stew": "maraq bakayle",
  "item.minecraft.rabbit_foot": "bakeyle lugtiis",
  "item.minecraft.rabbit_hide": "maraq bakayle",
  "item.minecraft.armor_stand": "istaaga hubka",
  "item.minecraft.iron_horse_armor": "hubka faraska birta",
  "item.minecraft.golden_horse_armor": "hubka fardaha dahabiga ah",
  "item.minecraft.diamond_horse_armor": "hubka horse dheeman",
  "item.minecraft.leather_horse_armor": "hubka horse leather",
  "item.minecraft.lead": "xadhig",
  "item.minecraft.name_tag": "magaca",
  "item.minecraft.command_block_minecart": "gaari miinada oo leh taliska joojinta",
  "item.minecraft.mutton": "hilib ido cayriin",
  "item.minecraft.cooked_mutton": "hilib ido lakariyey",
  "block.minecraft.white_banner": "calan cad",
  "block.minecraft.orange_banner": "calan oranji",
  "block.minecraft.magenta_banner": "calan magenta",
  "block.minecraft.light_blue_banner": "calan buluug khafiif ah",
  "block.minecraft.yellow_banner": "calan jaalle",
  "block.minecraft.lime_banner": "calan cagaaran oo khafiif ah",
  "block.minecraft.pink_banner": "calan casaan ah",
  "block.minecraft.gray_banner": "calan cawlan",
  "block.minecraft.light_gray_banner": "calan cawlan fudud",
  "block.minecraft.cyan_banner": "calan buluug khafiif ah",
  "block.minecraft.purple_banner": "calan guduudan",
  "block.minecraft.blue_banner": "calan buluug ah",
  "block.minecraft.brown_banner": "calan bunni ah",
  "block.minecraft.green_banner": "calan cagaaran",
  "block.minecraft.red_banner": "calan cas",
  "block.minecraft.black_banner": "calan madow",
  "item.minecraft.end_crystal": "dhamaad crystal",
  "item.minecraft.chorus_fruit": "miraha chorus",
  "item.minecraft.popped_chorus_fruit": "miraha chorus ee soo booday",
  "item.minecraft.beetroot": "sharbeed",
  "item.minecraft.beetroot_seeds": "abuurka beetroot",
  "item.minecraft.beetroot_soup": "maraqa beetroot",
  "item.minecraft.dragon_breath": "neefta dragon",
  "item.minecraft.splash_potion": "daawada aan la farsamayn karin□saamayn la'aan",
  "item.minecraft.spectral_arrow": "falaadha rooxaanta",
  "item.minecraft.tipped_arrow": "falaadhi tibaaxeed oo aan la farsamayn karin□saamayn la'aan",
  "item.minecraft.lingering_potion": "daawada aan la farsamayn karin□saamayn la'aan",
  "item.minecraft.shield": "gaashaanka",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "gran doon",
  "item.minecraft.birch_boat": "bjørk doon",
  "item.minecraft.jungle_boat": "kaynta doon",
  "item.minecraft.acacia_boat": "qudhac doon",
  "item.minecraft.dark_oak_boat": "doomaha madow ee geedka",
  "item.minecraft.totem_of_undying": "totem ee dhimashada",
  "item.minecraft.shulker_shell": "shulker qolof",
  "item.minecraft.iron_nugget": "xabbad bir",
  "item.minecraft.knowledge_book": "buugga aqoonta",
  "item.minecraft.debug_stick": "usha ka saar",
  "item.minecraft.music_disc_13": "cajalka musgah□c418 - 13",
  "item.minecraft.music_disc_cat": "cajalka musgah□c418 - bisad",
  "item.minecraft.music_disc_blocks": "cajalka musgah□c418 - xannibids",
  "item.minecraft.music_disc_chirp": "cajalka musgah□c418 - qaylo",
  "item.minecraft.music_disc_far": "cajalka musgah□c418 - fog",
  "item.minecraft.music_disc_mall": "cajalka musgah□c418 - mall",
  "item.minecraft.music_disc_mellohi": "cajalka musgah□c418 - mellohi",
  "item.minecraft.music_disc_stal": "cajalka musgah□c418 - stal",
  "item.minecraft.music_disc_strad": "cajalka musgah□c418 - strad",
  "item.minecraft.music_disc_ward": "cajalka musgah□c418 - ward",
  "item.minecraft.music_disc_11": "cajalka musgah□c418 - 11",
  "item.minecraft.music_disc_wait": "cajalka musgah□c418 - sug",
  "item.minecraft.music_disc_pigstep": "cajalka musgah□lena raine - pigstep",
  "item.minecraft.trident": "trident□□markaad ku jirto gacanta ugu muhiimsan:□+8 burburka weerarka□-2.9 xawaaraha weerarka",
  "item.minecraft.phantom_membrane": "dahaarka phantom",
  "item.minecraft.nautilus_shell": "qolof nautilus",
  "item.minecraft.heart_of_the_sea": "wadnaha badda",
  "item.minecraft.crossbow": "isbaaro",
  "item.minecraft.suspicious_stew": "feejignaan shaki",
  "block.minecraft.loom": "dhar",
  "item.minecraft.flower_banner_pattern": "qaabka xayeysiiska□kharashka ubaxa",
  "item.minecraft.creeper_banner_pattern": "qaabka xayeysiiska□qiimo badan",
  "item.minecraft.skull_banner_pattern": "qaabka xayeysiiska□kharashka kafeega",
  "item.minecraft.mojang_banner_pattern": "qaabka xayeysiiska□shay",
  "item.minecraft.globe_banner_pattern": "qaabka calanka□caalamka",
  "item.minecraft.piglin_banner_pattern": "qaabka xayeysiiska□cunto",
  "block.minecraft.composter": "dib u warshadaynta",
  "block.minecraft.barrel": "foosto",
  "block.minecraft.smoker": "sigaarka",
  "block.minecraft.blast_furnace": "foornada qarxa",
  "block.minecraft.cartography_table": "miiska sawirka",
  "block.minecraft.fletching_table": "miis jeexan",
  "block.minecraft.grindstone": "garaacid",
  "block.minecraft.lectern": "lectern",
  "block.minecraft.smithing_table": "miiska jumlada",
  "block.minecraft.stonecutter": "dhagxaan",
  "block.minecraft.bell": "jal",
  "block.minecraft.lantern": "cirifka",
  "block.minecraft.soul_lantern": "nalalka",
  "item.minecraft.sweet_berries": "berry macaan",
  "block.minecraft.campfire": "xarada dabkah",
  "block.minecraft.soul_campfire": "nafta xerada dabka",
  "block.minecraft.shroomlight": "nalka shubka",
  "item.minecraft.honeycomb": "malab",
  "block.minecraft.bee_nest": "shinni buul",
  "block.minecraft.beehive": "guri shinni",
  "item.minecraft.honey_bottle": "dhalada malabka",
  "block.minecraft.honey_block": "malab block",
  "block.minecraft.honeycomb_block": "xanibida malab",
  "block.minecraft.lodestone": "lodestone",
  "block.minecraft.netherite_block": "xirmooyinka netherite",
  "block.minecraft.ancient_debris": "burburkii qadiimiga ahaa",
  "block.minecraft.target": "bartilmaameed",
  "block.minecraft.crying_obsidian": "oohinta obsidian",
  "block.minecraft.blackstone": "madoow",
  "block.minecraft.blackstone_slab": "blackstone slab",
  "block.minecraft.blackstone_stairs": "jaranjarada madoow",
  "block.minecraft.gilded_blackstone": "gelded blackstone",
  "block.minecraft.polished_blackstone": "madoowga madoow",
  "block.minecraft.polished_blackstone_slab": "madoowga madoow",
  "block.minecraft.polished_blackstone_stairs": "jaranjarada madoow",
  "block.minecraft.chiseled_polished_blackstone": "dhagax dallaaley ah",
  "block.minecraft.polished_blackstone_bricks": "laydhka madoow ee la dhajiyay",
  "block.minecraft.polished_blackstone_brick_slab": "dhagaxa madow ee loo yaqaan 'blackstone brick slab'",
  "block.minecraft.polished_blackstone_brick_stairs": "jaranjarada dhagaxa ah ee loo yaqaan 'blackstone briit'",
  "block.minecraft.cracked_polished_blackstone_bricks": "dhagax madoow oo la jeexjeexay",
  "block.minecraft.respawn_anchor": "dib-u-hagaajinta xarigga",
}
export const so_so = items; 
